/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import {
  ButtonPrimary,
  ButtonSecondary,
  Card,
  Heading,
} from '@americanexpress/dls-react';
import registerStyles from '../../../styles/registerStyles';

const Welcome = ({ onSignUpClick, onLoginClick }) => (
  <div className="margin-4-t">
    <Heading
      level={1}
      headingStyle="heading5"
      style={{ fontWeight: '500', color: '#00175A' }}
    >
      Welcome to the Registration Page for File Exchange Express
    </Heading>
    <div className="pad-tb">
      <h3 className="label-2 dls-bright-blue">Instructions</h3>
      <p className="pad-tb">
        This registration process will allow you to log into the File Exchange
        Express to manage file transfer related information. FileXpress now
        uses <strong>American Express Smart Sign-Up</strong> for a secure and
        seamless sign-in experience across American Express applications. 
        <strong>This is not the username and password you would use to transfer files.</strong>
      </p>
      <div>
        <Heading level={5} headingStyle="heading2">
          Logging into the File Exchange Express will currently allow you to:
        </Heading>
        <ul className="pad-tb">
          <li className="pad-1-l">
            Update contact information for yourself and your colleagues
          </li>
          <li className="pad-1-l">
            Update your password for the File Exchange Express
          </li>
          <li className="pad-1-l">Follow up on requested actions</li>
        </ul>
      </div>
      <div>
        <Heading level={5} headingStyle="heading2">
          There will be additional functions available in File Exchange Express in
          the future, to include:
        </Heading>
        <ul className="pad-tb">
          <li className="pad-1-l">
            Communication with your American Express point of contact
          </li>
          <li className="pad-1-l">Manage your remote server information</li>
          <li className="pad-1-l">Track files</li>
        </ul>
      </div>
    </div>

    <Heading level={5} headingStyle="heading2">
      Choose an option below to get started.
    </Heading>

    <Card className="margin-2-t" showAccentBar={false} theme={registerStyles['.optionCardContainer']}>
      <div className="row pad-responsive">
        <div className="col-md-6" css={registerStyles['.optionColumn']}>
          <Heading level={4} headingStyle="heading3">
            Create New Account
          </Heading>
          <p className="pad-1-tb body">
            For users who do not have an existing American Express account to log
            in to FileXpress.
          </p>
          <hr css={registerStyles['.optionDivider']} />
          <div css={registerStyles['.optionCardAction']}>
            <ButtonPrimary className="width-full" onClick={onSignUpClick}>
              Sign Up
            </ButtonPrimary>
          </div>
        </div>

        <div className="col-md-6" css={registerStyles['.optionColumn']}>
          <Heading level={4} headingStyle="heading3">
            Log In with Existing Account
          </Heading>
          <p className="pad-1-tb body">
            For users who already use another American Express application
            credentials, please log in to FileXpress.
          </p>
          <hr css={registerStyles['.optionDivider']} />
          <div css={registerStyles['.optionCardAction']}>
            <ButtonSecondary className="width-full" onClick={onLoginClick}>
              Log In
            </ButtonSecondary>
          </div>
        </div>
      </div>
    </Card>
  </div>
);

Welcome.propTypes = {
  onSignUpClick: PropTypes.func.isRequired,
  onLoginClick: PropTypes.func.isRequired,
};

export default Welcome;
